import React from 'react';

export { default as reducer } from './FleetsDashboardReducer';

export const FleetsDashboard = React.lazy(() => import('./FleetsDashboardContainer'));
